import { Component, OnInit } from "@angular/core";

import { Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";

@Component({
    selector: "app-setup-and-settings",
    templateUrl: "./setup-and-settings.component.html",
    styleUrls: ["./setup-and-settings.component.scss"],
    imports: [
        RouterLink,
        RouterLinkActive,
        RouterOutlet,
    ]
})
export class SetupAndSettingsComponent implements OnInit {
  user: any;
  data: any;
  company: any;

  constructor(
    private localStorage: LocalStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.company = this.localStorage.get("company");
  }
}
